const richtextContent = document.querySelectorAll('.richtext')

if (richtextContent.length) {
  richtextContent.forEach(insertButtons)
}

function insertButtons(element) {
  const content = element.innerHTML
  if (!content.includes('[B]')) return // Only run if content contains [B][/B] shortcodes

  const parser = new DOMParser()
  const serializer = new XMLSerializer()
  const doc = parser.parseFromString(content, 'text/html')

  // Process all <a> tags in the .richtext domtree
  doc.querySelectorAll('a').forEach((anchor) => {
    const innerHTML = anchor.innerHTML
    const matches = innerHTML.match(/\[B\](.*?)\[\/B\]/)

    if (matches) {
      // Replace [B]...[/B] with its content and add classes
      anchor.innerHTML = matches[1].trim()
      anchor.classList.add('btn', 'btn-solid')
    } else if (
      anchor.parentElement &&
      anchor.parentElement.innerHTML.match(/^\[B\].*<\/a>\[\/B\]$/)
    ) {
      // If <a> is surrounded by [B]...[/B], remove tags and add classes
      anchor.classList.add('btn', 'btn-solid')
      anchor.parentElement.innerHTML = anchor.outerHTML
        .replace(/^\[B\]/, '')
        .replace(/\[\/B\]$/, '')
    }
  })

  // Update the original element's content
  element.innerHTML = serializer.serializeToString(doc.body)
}
